<div [style]="componentSize">
  <div style="display: flex; justify-content: space-between; height: 18px">
    <div
      style="
        color: #757575;
        font-family: OpenSans;
        font-weight: 400;
        font-size: 10px;
        line-height: 16.95px;
        letter-spacing: 0.11px;
        vertical-align: middle;
      "
    >
      Completes/Expected/Goal
    </div>
    <div
      style="
        color: #565a5c;
        font-size: 13px;
        font-family: OpenSans;
        display: flex;
        justify-content: space-between;
      "
    >
      <p class="completes" [style]="completesColor">{{ this.completes }}</p>
      /
      <p class="expeted-goal-style">{{ this.expected }}/{{ this.goal }}</p>
    </div>
  </div>

  <div class="chart-div">
    <div class="black-bar" [style]="blackBar">
      <p class="expected-in-bar">
        {{ this.expected | cap }}
      </p>
    </div>
    <div class="arrow-svg" [style]="arrowPosition">
      <svg
        width="13"
        height="9"
        viewBox="0 0 13 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.68912 7.87641C6.9 8.42947 6.91175 8.42946 7.31088 7.87641L11.8512 1.5852C12.3285 0.92384 11.8559 0 11.0403 0H1.95972C1.14411 0 0.671535 0.923841 1.14883 1.58521L5.68912 7.87641Z"
          fill="#333333"
        />
      </svg>
    </div>
    <svg
      class="arrow-svg"
      [style]="arrowPosition"
      width="13"
      height="9"
      viewBox="0 0 13 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.68912 7.87641C6.9 8.42947 6.91175 8.42946 7.31088 7.87641L11.8512 1.5852C12.3285 0.92384 11.8559 0 11.0403 0H1.95972C1.14411 0 0.671535 0.923841 1.14883 1.58521L5.68912 7.87641Z"
        fill="#333333"
      />
    </svg>
    <div class="bar-handler">
      <div class="red-bar" [style]="redBarSize"></div>
      <div class="yellow-bar" [style]="yellowBarSize"></div>
      <div class="green-bar" [style]="greenBarSize"></div>
    </div>
  </div>
</div>
